/* eslint-disable no-underscore-dangle */
import React, {
    useCallback, useMemo, useState
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { useTranslator } from '@jutro/locale';
import metadata from './CoveredLocationsPage.metadata.json5';
import message from './CoveredLocationsPage.messages';
import ELInformationComponent from '../../components/CoveredLocations/Information/ELInformationComponent'

function CoveredLocationsPage(props) {

    const { wizardData: submissionVM, updateWizardData, viewModelService } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const {
        onValidate,
        initialValidation
    } = useValidation('CoveredLocationsPage');
    const [isError, setError] = useState(false);
    const translator = useTranslator();

    const locRiskPath = 'lobData.envLin.coverables.locRisks'

    const onNext = useCallback(
        async () => {

            const sfilteredLcts = _.filter(submissionVM.value.lobData.envLin.coverables.locRisks, (locRisk) => _.isEmpty(locRisk.coveredLocationsDetails.natureofOperations))
            
            if(sfilteredLcts.length !== 0) {
                setError(true)

                return false
            }
            
            setError(false)

            const { productCode } = submissionVM.value.baseData;
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const locRiskOverrides = useMemo(() => {
        const lockRiskList = _.get(submissionVM, locRiskPath, []);
        let overrides = [];

        if (!_.isEmpty(lockRiskList)) {
            overrides = lockRiskList?.children.map((lockRisk, index) => ({
                [`ELInformationComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    pathUpdated: `${locRiskPath}.children[${index}]`,
                    viewModelService,
                    index
                }
            }));
        }

        return Object.assign({}, ...overrides);
    }, [submissionVM, updateWizardData, viewModelService]);

    const overrideProps = {
        errorMsg: {
            message: message.errorMas,
            visible: isError
        },
        ...locRiskOverrides
    };

    const addCoveredLocations = useCallback(async () => {

        const covLocObj = {
            tempID: EntityUtil.nextId()
        };

        const { _xCenter, _dtoName } = submissionVM.lobData.envLin.coverables.locRisks;

        const covLocVM = viewModelService.create(covLocObj, _xCenter, _dtoName);

        if (_.isUndefined(covLocVM.liabilityExposures.value)) {
            const liabilityVM = viewModelService.create({ tempID: EntityUtil.nextId() }, covLocVM.liabilityExposures._xCenter, covLocVM.liabilityExposures._dtoName);

            covLocVM.liabilityExposures.value = liabilityVM.value
            covLocVM.liabilityExposures.isValidationReq.value = true
        }

        if (_.isUndefined(covLocVM.storageTankInformation.value)) {
            const detOfUpgChaMadToThe10 = submissionVM.baseData.preferredlanguage_Ext.value.code === PremierConstants.preferredFrenchCode ? translator(message.aucunMsg) : translator(message.noneMsg)
            const storageTankInfoObj = {
                tempID: EntityUtil.nextId(),
                numOfAboGroStoTan1: 0,
                numOfUndStoTan2: 0,
                isTheAHisOfLeaOr6: false,
                detOfUpgChaMadToThe10,
                havAnyRepOrUpgIncRel11: false,
                werAnyTanEveRemOrClo13: false,
                doeTheAppCurHavPolLia17: false,
                areTheAnyOilWatSepOn19: false,
                datOfLatOcc8: {
                    year: new Date().getFullYear(),
                    month: new Date().getMonth(),
                    day: new Date().getDay(),
                }
            }
            const storageTankInfoVM = viewModelService.create(storageTankInfoObj, covLocVM.storageTankInformation._xCenter, covLocVM.storageTankInformation._dtoName);

            covLocVM.storageTankInformation.value = storageTankInfoVM.value
            covLocVM.storageTankInformation.isValidationReq.value = true
        }

        if (_.isUndefined(covLocVM.coveredLocations.value)) {
            const coveredLocationsObj = {
                tempID: EntityUtil.nextId(),
                locSch17: true,
                retDat5: submissionVM.value.baseData.periodStartDate
            }

            const coveredLocationsVM = viewModelService.create(coveredLocationsObj, covLocVM.coveredLocations._xCenter, covLocVM.coveredLocations._dtoName);

            covLocVM.coveredLocations.value = coveredLocationsVM.value
            covLocVM.coveredLocations.isValidationReq.value = true
        }

        if (_.isUndefined(covLocVM.coveredLocationsDetails.value)) {
            const coveredLocationsDetailsObj = {
                tempID: EntityUtil.nextId(),
                lotSizSqFt37: 0,
                doAnyOfTheCovLocHav40: false
            }

            const coveredLocationsDetailsVM = viewModelService.create(coveredLocationsDetailsObj, covLocVM.coveredLocationsDetails._xCenter, covLocVM.coveredLocationsDetails._dtoName);

            covLocVM.coveredLocationsDetails.value = coveredLocationsDetailsVM.value
            covLocVM.coveredLocationsDetails.isValidationReq.value = coveredLocationsDetailsVM.value
        }

        submissionVM.lobData.envLin.coverables.locRisks.value = submissionVM.lobData.envLin.coverables.locRisks.value || []


        submissionVM.lobData.envLin.coverables.locRisks.pushElement(
            covLocVM
        );
        updateWizardData(submissionVM);
    },
        [submissionVM, viewModelService, updateWizardData, translator]
    );

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addCoveredLocations
        },
        resolveComponentMap: {
            ELInformationComponent
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const onSave = useCallback(
        async () => {

            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.envLin?.coverables?.locRisks?.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'CoveredLocationsPage', subVMCopy);
            
            return submissionVM;
        },
        [submissionVM]
    );

    const isDisableNext = () => !submissionVM.lobData.envLin.coverables.locRisks.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

CoveredLocationsPage.propTypes = wizardProps;
export default withViewModelService(CoveredLocationsPage);
